var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWarningFiled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 -960 960 960",
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.914-153q-10.414 0-18.131-4.7-7.718-4.7-12.283-12.3-5-7.5-4.25-16.75t5.25-17.75l360-598.5q4.5-8.5 12.276-12 7.775-3.5 16.25-3.5 8.474 0 16.224 3.5t12.25 12l360 598.5q4.5 8.5 5.25 17.75T869.5-170q-5 7.5-12.5 12.25T839.086-153H120.914ZM180-220h600L480-720 180-220Zm299.789-49Q494-269 504-278.789q10-9.79 10-24Q514-317 504.211-327q-9.79-10-24-10Q466-337 456-327.211q-10 9.79-10 24Q446-289 455.789-279q9.79 10 24 10Zm.5-115Q494-384 504-393.85q10-9.85 10-23.65v-122q0-13.8-9.789-23.65-9.79-9.85-23.5-9.85Q467-573 457-563.15q-10 9.85-10 23.65v122q0 13.8 9.789 23.65 9.79 9.85 23.5 9.85ZM480-470Z",
    fill: "#F59064"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarningFiled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning_filed.7a5aec8b.svg";
export { ForwardRef as ReactComponent };